'use client';

import type { Ref } from 'react';

import classnames from 'classnames';

import { Avatar } from '../avatar';
import { CopyToClipboard } from '../copy-to-clipboard';
import type { AccountProps } from './Account.types';

import styles from './Account.module.scss';

const HORIZONTAL_ELLIPSIS = '…';

export function Account({
  style,
  className,
  username,
  email,
  status,
  src,
  allowCopy = false,
  allowCopyLabel = 'Copiado',
  statusPosition = 'bottom',
  direction = 'right',
  size = 'md',
  testId = 'ui-account',
  rounded = false,
  ref,
  ...rest
}: AccountProps & { ref?: Ref<HTMLDivElement> }) {
  return (
    <div
      ref={ref}
      style={style}
      className={classnames(styles['account'], className)}
      data-testid={testId}
      {...rest}
    >
      <div className={styles['wrapper']}>
        {direction === 'right' && (
          <Avatar
            src={src}
            size={size}
            status={status}
            statusPosition={statusPosition}
            rounded={rounded}
          />
        )}
        <div
          className={classnames(
            styles['info-wrapper'],
            direction && styles[`info-wrapper--${direction}`],
          )}
        >
          <span
            className={classnames(
              styles['username'],
              size && styles[`username--${size}`],
            )}
          >
            {username.length > 30
              ? username.slice(0, 30) + HORIZONTAL_ELLIPSIS
              : username}
          </span>
          {allowCopy ? (
            <CopyToClipboard
              value={email}
              label={allowCopyLabel}
              size="xxs"
              className={styles['copy-to-clipboard']}
            >
              <span
                className={classnames(
                  styles['email'],
                  size && styles[`email--${size}`],
                )}
              >
                {email}
              </span>
            </CopyToClipboard>
          ) : (
            <span
              className={classnames(
                styles['email'],
                size && styles[`email--${size}`],
              )}
            >
              {email}
            </span>
          )}
        </div>
        {direction === 'left' && (
          <Avatar
            src={src}
            size={size}
            status={status}
            statusPosition={statusPosition}
            rounded={rounded}
          />
        )}
      </div>
    </div>
  );
}
